export default {
  image: {
    height: 'auto',
    maxWidth: '100%',
    display: 'block',
  },
};



// WEBPACK FOOTER //
// ./src/components/Image/Image.style.js